export default "__VITE_ASSET__CkiqANTj__"